"use client";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function FadeInCard2({ children, delay = 0, className = "" }) {
  // ✅ 只让 initial 在第一次 mount 生效
  const [shouldUseInitial, setShouldUseInitial] = useState(true);

  useEffect(() => {
    // 下一帧关闭 initial，后续交互不会再回到 initial 导致“跳”
    const id = requestAnimationFrame(() => setShouldUseInitial(false));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <motion.div
      initial={shouldUseInitial ? { opacity: 0, x: -60 } : false}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, ease: "easeOut", delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
